<finder-dfm *ngIf="svcResponse?.dfmData" [dfmData]="svcResponse.dfmData"></finder-dfm>
<div *ngIf="svcResponse" role="main"
    id="finderDetailsContainer-{{svcResponse.id}}"
    class="details-container finderDetailsContainer"
    finderInterstitialTrigger
    [interstitialLabels]="interstitialModal">
    <finder-currency-converter-widget *ngIf="svcResponse.currencyConverterEnabled"></finder-currency-converter-widget>
    <div class="upper-container">
        <finder-aag
            *ngIf="svcResponse.aagData"
            [aagData]="svcResponse.aagData"
            [mediaEngineData]="mediaEngineData"
            [entityTypeUrl]="svcResponse.entityTypeUrl"
            [entityId]="svcResponse.id">
        </finder-aag>
    </div>
    <finder-campaign-sticky-cta *ngIf="svcResponse.stickyCta"
        [stickyCtaData]="svcResponse.stickyCta"
        [class.hasnav]="contentNavigation"
    ></finder-campaign-sticky-cta>
    <finder-content-navigation
        *ngIf="contentNavigation"
        [links]="contentNavigation.links"
        [sidePolylines]="contentNavigation.sidePolylines"
        [cta]="contentNavigation.cta"
        [logo]="contentNavigation.logo"
        [ariaLabel]="contentNavigation?.ariaLabel"
        [disableMobile]="contentNavigation.disableMobile"
    ></finder-content-navigation>
    <hr aria-hidden="true" class="rule" *ngIf="!svcResponse?.horizontalRuleData"/>
    <finder-horizontal-rule
        *ngIf="svcResponse?.horizontalRuleData"
        position="top"
        [data]="svcResponse?.horizontalRuleData"
    ></finder-horizontal-rule>
    <div class="main-container">
        <div class="middle-container">
            <div class="important-message-section" *ngIf="svcResponse.importantMessage">
                <finder-important-message [message]="svcResponse.importantMessage"></finder-important-message>
                <hr aria-hidden="true" class="rule" />
            </div>
            <div class="featured-menu-items-section" *ngIf="svcResponse.featuredMenuItems">
                <finder-featured-menu-items [menu]="svcResponse.featuredMenuItems"></finder-featured-menu-items>
                <hr aria-hidden="true" class="rule" />
            </div>
            <finder-content-header *ngIf="svcResponse.headerData"
                [headerData]="svcResponse.headerData"
                isDetailPage="true"
            ></finder-content-header>
            <finder-countdown-clock *ngIf="svcResponse.countdownClock" [countdownClockData]="svcResponse.countdownClock"></finder-countdown-clock>
            <div class="middle-section content-block"
                [@middleContainerState]="mapState">
                <div class="storycards-section" *ngIf="showStoryCards"
                    [@middleSectionState]="mapState">
                    <ng-container *ngIf="svcResponse.learnMore?.length > 0">
                        <finder-learn-more
                            *ngFor="let learnMore of svcResponse.learnMore"
                            [title]="learnMore.title"
                            [imageData]="learnMore.image"
                            [link]="learnMore.link"
                            [linkText]="learnMore.linkText">
                        </finder-learn-more>
                        <hr aria-hidden="true" />
                    </ng-container>
                    <h4 *ngIf="svcResponse.storycards?.title" class="storycards-title">
                        {{ svcResponse.storycards.title }}
                    </h4>
                    <finder-storycard
                        *ngFor="let storycard of svcResponse.storycards?.data"
                        [data]="storycard">
                    </finder-storycard>
                </div>
                <div *ngIf="showMap || showPromos"
                    class="map-section"
                    [@mapSectionState]="mapState"
                    (@mapSectionState.start)='startResizingMap()'
                    [ngClass]="{'expanded': mapExpanded || !showStoryCards}">
                    <finder-promo-group *ngIf="showPromos" [promos]="svcResponse.promos"></finder-promo-group>
                    @defer {
                        <finder-detail-map
                            *ngIf="showMap"
                            (mapExpanded)="toggleMapState($event)"
                            (mapIsReady)="mapIsReady($event)"
                            [expanded]="mapExpanded || !showStoryCards"
                            [hideCloseButton]="!showStoryCards"
                            [mapData]="svcResponse.map">
                        </finder-detail-map>
                    }
                </div>
                <finder-trip-advisor
                    class="trip-advisor"
                    [reviews]="svcResponse.tripAdvisor"
                    *ngIf="svcResponse.tripAdvisor">
                </finder-trip-advisor>
                <div *ngIf="showParticipatingRestaurants" class="participating-restaurants">
                    <hr aria-hidden="true" class="rule" />
                    <finder-participating-restaurants
                        [restaurantData]="svcResponse.participatingRestaurants">
                    </finder-participating-restaurants>
                </div>
                <div *ngIf="showSeatingChart"
                    class="seating-chart"
                    finderScrollTo="seating-chart"
                >
                    <hr aria-hidden="true" class="rule" />
                    <finder-seating-chart
                        [seatingChart]="svcResponse.seatingChart">
                    </finder-seating-chart>
                </div>
                <div *ngIf="showNdre"
                    class="ndre-section"
                    finderScrollTo="ndre-section"
                >
                    <hr aria-hidden="true" class="rule" *ngIf="showPackageCardsSeparator"/>
                    <ng-container *ngIf="showPackageCards">
                        <finder-sample-packages *ngFor="let packageCards of svcResponse.packageCards.packages"
                            [packagesData]="packageCards">
                        </finder-sample-packages>
                        <finder-promo-group *ngIf="svcResponse.packageCards.ctas?.length > 0"
                            [promos]="svcResponse.packageCards.ctas">
                        </finder-promo-group>
                    </ng-container>
                    <finder-text *ngIf="showExtraEnchantment" class="content-block"
                        [textData]="svcResponse.extraEnchantment">
                    </finder-text>
                    <hr aria-hidden="true" class="rule" *ngIf="showExtraEnchantment && showKnowBeforeYouGo" />
                    <finder-text *ngIf="showKnowBeforeYouGo" class="content-block"
                        [textData]="svcResponse.knowBeforeYouGo"
                        [class]="'know-before-you-go'">
                    </finder-text>
                </div>
                <finder-merchandise-group *ngIf="svcResponse.merchandiseGroup"
                    finderScrollTo="merchandise"
                    [merchandiseData]="svcResponse.merchandiseGroup">
                </finder-merchandise-group>
                <div class="guest-service-maps" *ngIf="svcResponse.guestServicesData">
                    <finder-guest-service-map
                        [guestServicesData]="svcResponse.guestServicesData"
                        [mapData]="svcResponse.map"
                    >
                    </finder-guest-service-map>
                </div>
                <!-- We should leave this for now since it supports multiple package cards -->
                <ng-container *ngIf="useComponentOrder">
                    <div class="component-order">
                        <!-- *ngIf and *ngFor can't be used on the same element -->
                        <ng-container *ngFor="let component of svcResponse.componentOrder" [ngSwitch]="component.block">
                            <ng-container *ngSwitchCase="COMPONENT_TYPES.textBlocks">
                                <ng-container *ngTemplateOutlet="textBlock; context: {textBlock: svcResponse.textBlocks[component.subBlock]}"></ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="COMPONENT_TYPES.availabilityCalendar">
                                <ng-container *ngTemplateOutlet="availabilityCalendar"></ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="COMPONENT_TYPES.pricingGrid">
                                <ng-container *ngTemplateOutlet="pricingGrid"></ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="COMPONENT_TYPES.visualItinerary">
                                <ng-container *ngTemplateOutlet="visualItinerary" ></ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="COMPONENT_TYPES.stepBlock">
                                <ng-container *ngTemplateOutlet="stepBlock"></ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="COMPONENT_TYPES.deckPlan">
                                <ng-container *ngTemplateOutlet="deckPlan"></ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="COMPONENT_TYPES.packageCardBlocks">
                                <ng-container *ngTemplateOutlet="packageCard; context: {packageCardBlock: svcResponse.packageCardBlocks[component.subBlock]} "></ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="COMPONENT_TYPES.tutorial">
                                <ng-container *ngTemplateOutlet="tutorial"></ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="COMPONENT_TYPES.sharedTable">
                                <ng-container *ngTemplateOutlet="sharedTable"></ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                </ng-container>
                <ng-template #textBlock let-textBlock="textBlock">
                    <ng-container [ngSwitch]="textBlock.type">
                        <finder-generic-text
                            *ngSwitchCase="BLOCK_TYPES.genericText"
                            [finderScrollTo]="textBlock.id"
                            [data]="textBlock"
                        ></finder-generic-text>
                        <finder-descriptive-text
                            *ngSwitchCase="BLOCK_TYPES.descriptiveText"
                            [finderScrollTo]="textBlock.id"
                            [data]="textBlock"
                            [useMediaGallery]="textBlock?.mediaEngine ? true : false"
                        ></finder-descriptive-text>
                    </ng-container>
                </ng-template>
                <ng-template #deckPlan>
                    <finder-iframe
                        [headerData]="svcResponse.deckPlan.headerData"
                        [iframeData]="svcResponse.deckPlan.iframeData"
                    ></finder-iframe>
                </ng-template>
                <ng-template #availabilityCalendar>
                    <finder-availability-calendar
                        *ngIf="showAvailabilityCalendar"
                        [finderScrollTo]="svcResponse.availabilityCalendar.id"
                        [data]="svcResponse.availabilityCalendar"
                    >
                    </finder-availability-calendar>
                </ng-template>
                <ng-template #pricingGrid>
                    <finder-pricing-grid
                        class="pricing-grid"
                        [finderScrollTo]="svcResponse.pricingGrid.id"
                        *ngIf="showPricingGrid"
                        [data]="svcResponse.pricingGrid"
                    ></finder-pricing-grid>
                </ng-template>
                <ng-template #visualItinerary>
                    <finder-visual-itinerary
                        *ngIf="showVisualItinerary"
                        [finderScrollTo]="svcResponse.visualItinerary.id"
                        [data]="svcResponse.visualItinerary"
                    ></finder-visual-itinerary>
                </ng-template>
                <ng-template #stepBlock>
                    <finder-step-block
                        *ngIf="showStepBlock"
                        [data]="svcResponse.stepBlock"
                    ></finder-step-block>
                </ng-template>
                <ng-template #packageCard let-packageCardBlock="packageCardBlock">
                    <finder-sample-packages [packagesData]="packageCardBlock"></finder-sample-packages>
                </ng-template>
                <ng-template #tutorial>
                    <finder-tutorial
                        *ngIf="showTutorial"
                        [data]="svcResponse.tutorial"
                    ></finder-tutorial>
                </ng-template>
                <ng-template #sharedTable>
                    <finder-shared-table
                        *ngIf="showSharedTable"
                        [data]="svcResponse['shared-table']">
                    </finder-shared-table>
                </ng-template>
                <!-- We should leave this for now since it supports multiple package cards -->
            </div>
        </div>
        <div *ngIf="svcResponse.blockData" class="block-container">
            <finder-block-layout-renderer
                [blocks]="svcResponse.blockData"
                [theme]="svcResponse.themeData"
            ></finder-block-layout-renderer>
        </div>
        <!-- All the "other" bits -->
        <div class="lower-container" *ngIf="svcResponse.disableLowerContainer !== true">
            <finder-avatar-list
                *ngIf="svcResponse.avatarList"
                [title]="svcResponse.avatarList.title"
                [avatarList]="svcResponse.avatarList.list">
            </finder-avatar-list>
            <finder-promo-banner
                *ngIf="svcResponse.promoBanner"
                [promoData]="svcResponse.promoBanner"
            ></finder-promo-banner>
            <hr aria-hidden="true" class="rule" *ngIf="showRelatedActivities || showPromos || showGAV || showMoreLikeThis"/>
            <div *ngIf="showRelatedActivities"
                (finderInViewport)="related = $event"
                [finderTransitionIn]="related"
                class="content-block">
                <finder-related-activities
                    [relatedData]="svcResponse.relatedActivities">
                </finder-related-activities>
            </div>
            <div class="content-block"
                [ngClass]="{'hide-gav': !showGAV}">
                <finder-guests-also-viewed
                    [gavTitle]="svcResponse.guestsAlsoViewed">
                </finder-guests-also-viewed>
            </div>
            <div *ngIf="showMoreLikeThis"
                (finderInViewport)="more = $event"
                [finderTransitionIn]="more"
                class="content-block">
                <finder-more-like-this
                    [title]="svcResponse.moreLikeThis.title"
                    [links]="svcResponse.moreLikeThis.links"
                    [entityTypeUrl]="svcResponse.entityTypeUrl">
                </finder-more-like-this>
            </div>
            <div *ngIf="showDisclaimer">
                <hr aria-hidden="true" aria-hidden="true" class="rule" />
                <finder-text class="disclaimer"
                    [textData]="svcResponse.disclaimer">
                </finder-text>
            </div>
        </div>
    </div>
</div>
